import { Grid, Cell } from 'components/Grid';
import { NO_ELEMENT, hasElements } from 'utils';
import { Section } from 'components/Section';
import { isMobile, isTabletLayout } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import styles from './articleSection.scss';
import { EditorialLink } from 'models/EditorialLink';
import { Editorial } from 'components/Editorials/editorials';

interface GetCountToShowProps {
  isMobile: boolean;
  isTablet: boolean;
}

const getCountToShow = ({ isMobile, isTablet }: GetCountToShowProps): number => {
  const COUNT_MOBILE = 4;
  const COUNT_TABLET = 3;
  const COUNT_DESKTOP = 5;

  if (isMobile) {
    return COUNT_MOBILE;
  }

  if (isTablet) {
    return COUNT_TABLET;
  }

  return COUNT_DESKTOP;
};

const useSizes = () => {
  const _isMobile = useSelector(isMobile);
  const _isTablet = useSelector(isTabletLayout);

  return {
    isMobile: _isMobile,
    isTablet: _isTablet
  };
};

interface ArticleSectionProps {
  sectionTitle: string | undefined;
  articles: EditorialLink[];
}

export const ArticleSection = ({ articles, sectionTitle }: ArticleSectionProps) => {
  const { isMobile, isTablet } = useSizes();

  if (!hasElements(articles)) {
    return NO_ELEMENT;
  }

  const amountOfArticles = getCountToShow({ isMobile, isTablet });

  const content = articles.slice(0, amountOfArticles).map((article: EditorialLink) => (
    <Cell key={article.url}>
      <Editorial {...article} showIntroduction={!isMobile} />
    </Cell>
  ));

  return (
    <Section title={sectionTitle} className={styles.section}>
      <Grid
        huge="5"
        tablet="3"
        desktop="4"
        phone="2"
        gutters="large"
        className={styles.gridStyling}
      >
        {content}
      </Grid>
    </Section>
  );
};
